(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["SwaggerEditorStandalonePreset"] = factory(require("React"));
	else
		root["SwaggerEditorStandalonePreset"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_130__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition